import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Products/Handlers/LoadProductByPath";

addToChainAfter(chain, PopulateApiParameter, props => {
    if (!props.apiParameter.expand) {
        props.apiParameter.expand = ["properties"];
        return;
    }

    if (props.apiParameter.expand.indexOf("properties") === -1) {
        props.apiParameter.expand = [...props.apiParameter.expand, "properties"];
    }
});
